import { AppDispatch } from '@/store'
import { authSlice } from '../features/auth/authSlice'

export const useSignOut = () => async (dispatch: AppDispatch) => {
  dispatch(authSlice.actions.signOut())
}
